import { isProcurement } from "../../service/oneClickIs"
import type EstimateValues from "../../types/params"

type NoResetValues = Pick<EstimateValues, "serviceD" | "serviceM" | "serviceG">
type NoResetValuesForProcurement = Partial<
  Pick<
    EstimateValues,
    | "partsProcurementCourse"
    | "sheetCnt"
    | "pieceCnt"
    | "bgacsp"
    | "dipPartCnt"
    | "freeMaterialsFlg"
    | "userProvPartFlg"
    | "panelizedItemCnt"
    | "panelizedItemKindCnt"
  >
>

const getNoResetValues = (values: EstimateValues): NoResetValues & NoResetValuesForProcurement => {
  const {
    serviceD,
    serviceM,
    serviceG,

    partsProcurementCourse,
    sheetCnt,
    pieceCnt,
    bgacsp,
    dipPartCnt,
    freeMaterialsFlg,
    userProvPartFlg,
    panelizedItemCnt,
    panelizedItemKindCnt,
  } = values

  const base = {
    serviceD,
    serviceM,
    serviceG,
  }

  if (isProcurement(values)) {
    return {
      ...base,
      partsProcurementCourse,
      sheetCnt,
      pieceCnt,
      bgacsp,
      dipPartCnt,
      freeMaterialsFlg,
      userProvPartFlg,
      panelizedItemCnt,
      panelizedItemKindCnt,
    }
  }

  return base
}

export default getNoResetValues
